import React, { useContext, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toastMsg } from "../component/toast";
import { AppContext } from "../context/AppContext";
import { PostCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import CustomButton from "../component/button";
import { formatToDDMMYYYY } from "../common";

function AddNotes({ isAddNotes, setIsAddNotes, notes, userId, setNotes, userName, codeId, handleGetNotes, getList, code,
  isBulkNotes,
  selectsRec,
  setIsBulkNotes }) {


  const [newNote, setNewNote] = useState("");

  const [isLoading, setIsloading] = useState(false)

  const { adminData } = useContext(AppContext)

  const handleAddNote = () => {

    let n = newNote?.trim()

    if (!n) {
      toastMsg('error', 'Please Enter Note To Add')

      return
    }

    let candidates = []

    if(isBulkNotes){
      candidates = selectsRec?.map(item => item.userId);
    }else{
      candidates.push(userId)
    }

    let payload = {
      "userIds": candidates,
      "codeId": codeId,
      "email": adminData?.email,
      "note": n
    }

    setIsloading(true)

    PostCallWithErrorResponse(ApiConfig.ADD_NOTE, payload).then((res) => {

      if (res?.json?.succeded) {
        toastMsg('success', res?.json?.message || res?.json?.response)
        if(!isBulkNotes){
        handleGetNotes(codeId, userId)
        }
        setNewNote("");
        getList(code)
        

      }

      setIsloading(false)

    })




  };

  return (
    <Modal
      show={isAddNotes}
      size="lg"
      centered
      dialogClassName="modal-h-650"
      onHide={() => {

        setIsAddNotes(false)
        setIsBulkNotes(false)
        setNotes([])

      }}
    >
      <Modal.Header closeButton className="custom-close-btn">
        <h4 className="mb-0 mt-1 fw-medium">{userName}</h4>
      </Modal.Header>

      <Modal.Body>
        <div style={isBulkNotes?{}: {
          minHeight: '330px', maxHeight: '330px', overflow: 'scroll', scrollbarWidth: "none",     // Firefox
          msOverflowStyle: "none"
        }}>
          {notes.map((note, index) => (
            <div key={index} className="mb-2">
              <div className="d-flex justify-content-between">
                <small>{note.writer}</small>
                <small>{note.email}</small>
              </div>
              <div style={{ padding: '4px', border: '1px solid var(--ui-border)', borderRadius: '5px', fontFamily: 'var(--ff-font-family-inter) !important' }}>
                {note.notes}
              </div>
              {/* <Form.Control
                as="textarea"
                rows={2}
                value={note.notes}
                readOnly
                className="mt-1"
              /> */}
              <div className="d-flex justify-content-end">
                <small>{formatToDDMMYYYY(note?.createdAt,'dd-mm-yy HH:mm')}</small>
              </div>
            </div>
          ))}
        </div>

        <div className={`${isBulkNotes?'':"mt-3"}`}>
          <Form.Label className="fw">Add Note:</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            className="note-input"
            value={newNote}
            onChange={(e) => {
              if (e.target.value.length <= 1000) {
                setNewNote(e.target.value)
              } else {
                toastMsg('error', 'Note should be less than 1000 characters')
              }
            }
            }
            placeholder="Write your note here..."
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton title="Add"
          handleClick={handleAddNote}
          isLoading={isLoading}
        />

      </Modal.Footer>
    </Modal >
  );
}

export default AddNotes;
